export type SeatStatus =
  "available" | "selected" | "buying" | "purchased" | "subscriber";

// `seat` colors the SVG through currentColor; `label` colors the seat number.
export const SEAT_STATUS: Record<
  SeatStatus,
  {text: string; seat: string; label: string}
> = {
  available: {
    text: "Disponible",
    seat: "text-emerald-600",
    label: "text-white",
  },
  selected: {
    text: "Tu selección",
    seat: "text-primary-500",
    label: "text-neutral-900",
  },
  buying: {
    text: "En compra",
    seat: "text-sky-300 dark:text-sky-800 motion-safe:animate-pulse",
    label: "text-sky-900 dark:text-sky-100",
  },
  purchased: {
    text: "Ocupado",
    seat: "text-neutral-300 dark:text-neutral-700",
    label: "text-neutral-500 dark:text-neutral-400",
  },
  subscriber: {
    text: "Abonado",
    seat: "text-violet-300 dark:text-violet-800",
    label: "text-violet-900 dark:text-violet-200",
  },
};

export const SEAT_STATUS_ORDER: SeatStatus[] = [
  "available",
  "selected",
  "buying",
  "purchased",
  "subscriber",
];
